import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API_IP } from "../global_variables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faXmark,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import "./NavBar.css";

const NavBar = ({
  loggedIn,
  setLogin,
  setSelectedSection,
  toggleSidebar,
  setSelectedCareService,
}) => {
  const [services, setServices] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const navRef = useRef(null);

  const profileMenuList = [
    { name: "Account", screen: "Account" },
    { name: "Calendar", screen: "Calendar" },
    { name: "Self/Family Profiles", screen: "Patient" },
  ];

  const imgList = {
    Bathing: 13,
    Laundry: 12,
    "Groccery Shopping": 11,
    Transferring: 10,
    Eating: 9,
    "Personal Errands": 8,
    Showers: 7,
    Dressing: 6,
    "Hygiene/Grooming": 5,
    "Meal Preparation": 4,
    "Declutter/Organization": 3,
    Ambulating: 2,
    "Medication Management": 1,
    "Transport to/from appointments": 10,
  };

  const fetchServices = async () => {
    try {
      const response = await axios.get(`${API_IP}/api/services`);
      setServices(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleLogout = () => {
    ["token", "username", "userId", "isAdmin"].forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
    setLogin(false);
    setIsMobileMenuOpen(false);
    navigate("/");
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  const handleClickOutside = (event) => {
    if (navRef.current && !navRef.current.contains(event.target)) {
      setActiveDropdown(null);
    }
  };

  useEffect(() => {
    fetchServices();
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="NavBar-container" ref={navRef}>
      <div className="NavBar-left-box">
        <Link className="NavBar-logo-anchor" to="/" onClick={closeMobileMenu}>
          <img
            className="NavBar-brand-img"
            src={require("../images/iCareVillage_logo.webp")}
            alt="iCareVillage Logo"
          />
        </Link>
      </div>

      <div className="NavBar-mobile-buttons">
        {currentPath === "/UserHome" && loggedIn && (
          <button
            className="NavBar-hamburger-btn"
            onClick={() => toggleSidebar()}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        )}
        <button
          className="NavBar-hamburger-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <FontAwesomeIcon icon={isMobileMenuOpen ? faXmark : faBars} />
        </button>
      </div>

      <div
        className={`NavBar-drawer-overlay ${isMobileMenuOpen ? "active" : ""}`}
        onClick={closeMobileMenu}
      ></div>

      <nav className={`NavBar-nav-core ${isMobileMenuOpen ? "open" : ""}`}>
        <div className="NavBar-mobile-header">
          <img
            className="NavBar-brand-img"
            src={require("../images/iCareVillage_logo.webp")}
            alt="iCareVillage Logo"
          />
          <button className="NavBar-hamburger-btn" onClick={closeMobileMenu}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        <ul className="NavBar-center-links">
          {loggedIn && (
            <li>
              <Link
                className="NavBar-link-text"
                to="/main"
                onClick={closeMobileMenu}
              >
                Home
              </Link>
            </li>
          )}

          <li>
            <Link
              className="NavBar-link-text"
              to="/Services"
              onClick={closeMobileMenu}
            >
              Services
            </Link>
          </li>

          <li className="NavBar-dropdown-scope">
            <button
              className="NavBar-link-text NavBar-trigger"
              onClick={() => toggleDropdown("about")}
            >
              About Us{" "}
              <FontAwesomeIcon
                icon={faChevronDown}
                className="NavBar-chevron"
              />
            </button>
            <div
              className={`NavBar-dropdown-menu ${activeDropdown === "about" ? "show" : ""}`}
            >
              <Link
                to="/AboutUs"
                className="NavBar-dropdown-item-btn"
                onClick={closeMobileMenu}
              >
                Our Company
              </Link>
              <Link
                to="/OurLeadership"
                className="NavBar-dropdown-item-btn"
                onClick={closeMobileMenu}
              >
                Our Leadership
              </Link>
            </div>
          </li>

          <li>
            <Link
              className="NavBar-link-text"
              to="/ContactUs"
              onClick={closeMobileMenu}
            >
              Contact Us
            </Link>
          </li>
          <li>
            <Link
              className="NavBar-link-text"
              to="/Careers"
              onClick={closeMobileMenu}
            >
              Careers
            </Link>
          </li>

          <li className="NavBar-cta-wrapper">
            <Link
              to="/consultation"
              className="NavBar-btn-special NavBar-teal"
              onClick={closeMobileMenu}
            >
              FREE Consultation
            </Link>
            <Link
              to="/platform-orientation"
              className="NavBar-btn-special NavBar-orange"
              onClick={closeMobileMenu}
            >
              Platform Orientation
            </Link>
          </li>
        </ul>

        <div className="NavBar-right-box">
          {loggedIn ? (
            <div className="NavBar-dropdown-scope">
              <button
                className="NavBar-auth-btn NavBar-btn-outline"
                onClick={() => toggleDropdown("profile")}
              >
                My Profile{" "}
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className="NavBar-chevron"
                />
              </button>
              <div
                className={`NavBar-dropdown-menu NavBar-profile-side ${activeDropdown === "profile" ? "show" : ""}`}
              >
                {profileMenuList.map((profile, index) => (
                  <button
                    key={index}
                    className="NavBar-dropdown-item-btn"
                    onClick={() => {
                      closeMobileMenu();
                      toggleSidebar(false);
                      setSelectedSection(profile.screen);
                      navigate("/UserHome");
                    }}
                  >
                    {profile.name}
                  </button>
                ))}
                <div className="NavBar-divider"></div>
                <button
                  className="NavBar-dropdown-item-btn NavBar-danger"
                  onClick={handleLogout}
                >
                  Log Out
                </button>
              </div>
            </div>
          ) : (
            <div className="NavBar-login-group">
              <button
                className="NavBar-auth-btn NavBar-btn-outline"
                onClick={() => {
                  closeMobileMenu();
                  navigate("/register");
                }}
              >
                Register
              </button>
              <button
                className="NavBar-auth-btn NavBar-btn-primary"
                onClick={() => {
                  closeMobileMenu();
                  navigate("/login");
                }}
              >
                Log In
              </button>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
